import { PasswordInput } from "@/pages/(auth)/reset-password/components/password-input.tsx";
import {
  useFormErrorNotif,
  useFormSuccessNotif,
} from "@babackapp/react-hook-forms-components/form-notifications";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@babackapp/ui/components/form";
import PasswordStrengthBar from "react-password-strength-bar";
import { useNavigate } from "react-router-dom";
import { useResetPasswordForm } from "../hooks/use-reset-password-form";
import { useAuth } from "@babackapp/auth-client/hooks";
import { useState } from "react";

export const ResetPasswordForm = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const formErrorNotif = useFormErrorNotif();
  const formSuccessNotif = useFormSuccessNotif();
  const auth = useAuth();
  const form = useResetPasswordForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get reset token from URL
  const token = new URLSearchParams(window.location.search).get("token");

  const handleSubmit = form.handleSubmit(async (data) => {
    if (!token) {
      formErrorNotif({
        title: t("resetPassword.error.somethingWrong"),
      });
      return;
    }

    try {
      setIsSubmitting(true);
      await auth.resetPassword(token, data.password);

      formSuccessNotif({
        title: t("resetPassword.success.resetSuccess"),
      });
      navigate("/auth/sign-in");
    } catch (err: unknown) {
      console.error(err);
      formErrorNotif({
        title: t("resetPassword.error.somethingWrong"),
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  const isButtonDisabled =
    !form.formState.isDirty || isSubmitting || auth.isLoading;

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit}>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="space-y-6">
              <FormField
                name={"password"}
                control={form.control}
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormLabel>{t("accountSettings.newPassword")}</FormLabel>
                      <FormControl>
                        <PasswordInput {...field} />
                      </FormControl>
                      <div className="mt-2">
                        <PasswordStrengthBar password={field.value} />
                      </div>
                      <FormMessage />
                    </FormItem>
                  );
                }}
              />
              <FormField
                name={"passwordConfirmation"}
                control={form.control}
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormLabel>{t("accountSettings.newPassword1")}</FormLabel>
                      <FormControl>
                        <PasswordInput {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  );
                }}
              />
              <Button type={"submit"} disabled={isButtonDisabled} size="lg">
                {t("forgotPwd.reset")}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
};
